import React from 'react';

export default function Documents() {
  return (
    <>
      <h1 className="wp-portal__page-title">Documents</h1>
      <p className="wp-portal__page-sub">Agreements, registrations, and account documents.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          No documents available. Your publishing documents and agreements will
          appear here once your account has been fully set up.
        </p>
      </div>
    </>
  );
}
